import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleReactValidator from "simple-react-validator";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import BudgetMasterTable from "./prospectFieldMasterTable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import { clientAccess } from "../../utils/index";
import DatePicker from "react-datepicker";
import moment from "moment";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class ProspectMaster extends React.Component {
  state = {
    categories: [],
    isOpen: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    redirect: false,
    isSearchable: true,
    isClearable: true,
    isDisabled: this.props.match.params.id !== undefined ? true : false,
    url: `${apiUrl.apiUrl.url}/prospect/create-category`,
    id: undefined,
    initialValues: {
      category: "",
      title: "",
    },
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-category`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          categories: data['categories'],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/prospect/check-field-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  handleChangeCategory = (newValue, actionMeta) => {
    this.state.initialValues.categoryId = newValue.value;
    this.state.initialValues.categoryName = newValue.label;
    this.setState({});
    this.categoryId = newValue;
  };

  componentDidUpdate() {
    console.log('hihih');
    console.log(this.props.match, "===");

    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        // this.setState({
        //   url: `${apiUrl.apiUrl.url}/create-category`,
        //   initialValues: {
        //     category: "",
        //     title: "",
        //   },
        // });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/prospect/fetch-field?id=${this.props.match.params.id}`).then(function (response) {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/prospect/update-field?id=${athis.props.match.params.id}`,
            initialValues: data.data
          });

          const unitDetailsObject = athis.state.categories.find(item => item.key === data.data.category);

          athis.state.initialValues.categoryId = data.data.category;
          athis.state.initialValues.categoryName = unitDetailsObject.value;
          athis.setState({});

        }).catch(function () {});

        // fetch(
        //   `${apiUrl.apiUrl.url}/prospect/fetch-field?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/prospect/update-field?id=${this.props.match.params.id}`,
        //       initialValues: data.data
        //     });

        //     console.log(this.state.categories);
        //     const unitDetailsObject = this.state.categories.find(item => item.key === data.data.category);


        //     this.state.initialValues.categoryId = data.data.category;
        //     this.state.initialValues.categoryName = unitDetailsObject.value;
        //     this.setState({});
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }


  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/prospect/field-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        category: "",
        title: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      isDisabled: this.props.match.params.id !== undefined ? true : false,
      popupContent: "",
      initialValues: {
        category: "",
        title: ""
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/prospect" />;
    }
    return (
      <div
        className="parentContainer"

      >
        <div>
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/prospect">Prospect Master</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Prospect Master</Link>
              </li>
            </ul>
          </div>
        </div>


        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(this.validator.allValid(), "validation");

            values.category = this.state.initialValues.categoryId;
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                  url: `${apiUrl.apiUrl.url}/prospect/create-category`
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      <div className="newGridSectionInner">
                        <label>
                          Category <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="category"
                            onChange={(e) => {
                              this.handleChangeCategory(
                                e,
                                "change_client_group"
                              );
                            }}
                            value={{
                              label: this.state.initialValues.categoryName,
                              value: this.state.initialValues.categoryId,
                            }}
                            options={this.state.categories.map(

                              (item) => ({
                                label: item.value,
                                value: item.key
                              })
                            )}
                          />

                          <ErrorMessage
                            name="category"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Title <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="title"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <ErrorMessage
                            name="title"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}
                          className="delete_button"
                        >
                          Delete
                        </button>
                        <button
                          type="reset"
                          onClick={this.redirectAfterEdit}
                          className="reset_button"
                        >
                          <Link to="/masters/prospect">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" disabled={isSubmitting}
                          className="add_button">
                          Add
                        </button>
                        <button
                          type="reset"
                          className="reset_button"
                          onClick={this.redirectAfterEdit}
                        >
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>
              {/* <div className="unitFormContainer">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">

                      <>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Category <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                  name="category"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeCategory(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.categoryName,
                                    value: this.state.initialValues.categoryId,
                                  }}
                                  options={this.state.categories.map(

                                    (item) => ({
                                      label: item.value,
                                      value: item.key
                                    })
                                  )}
                                />

                                <ErrorMessage
                                  name="category"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Title <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Field
                                  type="text"
                                  name="title"
                                  //value={this.state.initialValues.totalArea}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                />
                                <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>


                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                <Link to="/masters/prospect">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <BudgetMasterTable />
      </div>
    );
  }
}

export default withRouter(ProspectMaster);
